import type { SYSAction } from "../../../../../../../_ovlclient/src"
import { HookScreenNavigateIn_ReturnType } from "../../../../../../../_ovlclient/src/global/hooks"
import {
  FieldVal,
  SYSField,
} from "../../../../../../../_ovlclient/src/library/forms/fieldapi"
import { FormInit } from "../../../../../../../_ovlclient/src/library/forms/formapi"
import { NewServiceStep1FormFieldKeys } from "../../../features/svl/svlnewservicestep1/formdef"
import { NewServiceStep2FormFieldKeys } from "../../../features/svl/svlnewservicestep2/formdef"
import { NewServiceStep3FormFieldsDef } from "../../../features/svl/svlnewservicestep3/formdef"

const HookScreenNavigateIn: SYSAction<any> = async (_, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let newService = state.app.global.SVL.NewService
  let formState = FormInit("SVLNewServiceStep3", NewServiceStep3FormFieldsDef, {
    doFormChangedForEveryFieldInInit: false,
  })

  let fieldsStep1 = state.ovl.forms["SVLNewServiceStep1"]["SVLNewServiceStep1"]
    .fields as {
    [key in NewServiceStep1FormFieldKeys]: SYSField
  }

  let fieldsStep2 = state.ovl.forms["SVLNewServiceStep2"]["SVLNewServiceStep2"]
    .fields as {
    [key in NewServiceStep2FormFieldKeys]: SYSField
  }
  let contact = newService.contact
  contact.mobilePhone = FieldVal(fieldsStep1.requesterPhone)
  if (!contact.id) {
    contact.cardGroup = FieldVal(fieldsStep2.requesterType).toString()
  }
  // always set c contact
  contact.firstNameC = FieldVal(fieldsStep2.requesterCFirstName)
  contact.lastNameC = FieldVal(fieldsStep2.requesterCLastName)
  contact.mobilePhoneC = FieldVal(fieldsStep2.requesterCPhone)
  contact.emailC = FieldVal(fieldsStep2.requesterCEmail)
}

export let hooks = { HookScreenNavigateIn }
